"use client";

import { Translation } from "@/data/lang";
import { ForecastPeriod } from "@/features/analysis/overview/financial-forecast/services/financial-forecast-chart";

type PeriodOption = {
  label: string;
  value: ForecastPeriod;
};

export const getPeriodOptions = ({ t }: { t: Translation }): PeriodOption[] => [
  {
    label: t.analysis.shared.dateOption.quarterly,
    value: "quarter",
  },
  {
    label: t.analysis.shared.dateOption.annually,
    value: "annual",
  },
];
